<template>
  <div class="main-right">
    <main-nav :data="mainnav" page="home"></main-nav>
    <div class="swiperBox">
      <div class = "adSwiper">
        <div class="prev"></div>
        <div class="next"></div>
        <ad-model :adCode="634"></ad-model>
      </div>
      <login></login>
    </div>
  </div>
</template>

<script>
import MainNav from '@/common-components/Mainnav'
import AdModel from '@/common-components/AdModel'
import Login from './components/Login'
import { mainnav } from 'js/home/mainnav.js'
export default {
  name: 'Mainswiper',
  components: {
    MainNav,
    AdModel,
    Login
  },
  data () {
    return {
      mainnav
    }
  }
}
</script>

<style lang="stylus" scoped>
  .main-right
    flex: 1
    float: left
    width: 1015px
    .swiperBox
      display: flex
      float: left
      .adSwiper
        width: 760px
        height: 330px
        position: relative
        float: left
</style>



// WEBPACK FOOTER //
// src/pages/home/components/swiper/components/right-part/Mainright.vue